export class File {
	constructor(
		public id: String,
		public name?: String,
		public documentTypeId?: String,
		public attributes?: any,
		public systemId?: String,
		public outputConfigId?: String) { }
}
